import React, { useEffect, useState } from "react";
import logo from "../../images/appLogoCrop.png";
import { AiOutlineExport } from "react-icons/ai";
import userIcon from "../../images/user.png";
import { IoMdNotificationsOutline } from "react-icons/io";
import { FaUserCircle } from "react-icons/fa";
import { GoMail } from "react-icons/go";
import { IoReorderThree } from "react-icons/io5";
import { FaExpandArrowsAlt } from "react-icons/fa";
import { IoIosSearch } from "react-icons/io";
import { TbSquareArrowDownFilled } from "react-icons/tb";
import { RxHamburgerMenu } from "react-icons/rx";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { base_url } from "../../utils/AxiosConfig";
// import cbxLogo from "../../images/product1.png";
// import { Button } from "../UI/Button";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const NavBar = ({ toggleShowSideBar }) => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const storedLoginUser =
    JSON.parse(localStorage.getItem("BondTimeLoginUserData")) || [];
  let user = null;
  let companyCode = null;

  if (storedLoginUser) {
    user = storedLoginUser[0].salesman_name?.trim();
  }

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const [allBranchData, setAllBranchData] = useState([]);
  const [showBranchDrop, setShowBranchDrop] = useState(false);
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState("");

  const fetchAllBranchData = async () => {
    try {
      const response = await axios.get(
        `${base_url}/api/MasterCount/${companyCode}/BRANCH/${user}/-`
      );

      if (response.status === 200) {
        setAllBranchData(response.data);
      }
    } catch (error) {
      console.log("fetchAllBranchDataErr", error);
    }
  };

  const toggleSearch = () => {
    setIsSearchVisible((prevState) => !prevState);
  };

  const navigate = useNavigate();

  const onSignOut = () => {
    // localStorage.clear();
    // navigate("/");
    navigate("/login");
  };

  useEffect(() => {
    const storedBranch = localStorage.getItem("BondTimeNavBranch");
    if (storedBranch) {
      setSelectedBranch(storedBranch);
    }
  }, []);

  useEffect(() => {
    if (user) {
      fetchAllBranchData();
    }
  }, [user]);

  const [branch, setBranch] = React.useState("");

  // const handleBranchClick = (item) => {
  //   console.log("handleBranchClicked", item);
  //   setShowBranchDrop(false);
  //   setSelectedBranch(item.trim());
  //   localStorage.setItem("BondTimeNavBranch", item.trim());
  // };

  const handleChange = (event) => {
    const selectedBranchValue = event.target.value;
    console.log("handleBranchClicked", selectedBranchValue);
    setBranch(selectedBranchValue);
    setSelectedBranch(selectedBranchValue.trim());
    localStorage.setItem("BondTimeNavBranch", selectedBranchValue.trim());
  };

  return (
    <div className="w-full bg-[#F3F2FA]">
    {/* <div className="w-full bg-[#DEDEDE]"> */}
      <div className="w-full flex relative">
        <div className="flex items-center p-2 cursor-pointer w-[42%] justify-start gap-3">
          <div className="md:hidden block" onClick={() => toggleShowSideBar()}>
            <RxHamburgerMenu />
          </div>

          <div className="w-[60%] flex justify-between">
            <img
              // className=" w-[43%] object-cover overflow-hidden"
              className="ml-4 w-[130px] h-[60px] object-fit overflow-hidden"
              src={logo}
              alt=""
              onClick={() => navigate("/admin/home")}
            />
          </div>
        </div>

       <div className="w-full  flex justify-end items-center gap-18 relative">
           {/* <div className="flex  mx-8">
            <img
              className="w-[120px] h-[40px] object-cover"
              src={cbxLogo}
              alt=""
            />

          </div> */}

          <div className="flex items-center border-1 border-[#757575] rounded-md py-2 px-3 me-4 mx-8 w-[25%]">
            <FaSearch className="text-blue-500 text-sm mr-2" />
            <input
              type="text"
              placeholder="Search"
              className="border-none outline-none bg-transparent flex-1 text-sm w-full"
            />
          </div>

          {/* <div
            className="flex justify-center items-center rounded-full bg-white p-[18px] w-10 h-10 cursor-pointer hover:shadow-[0px_7px_4px_-3px_rgba(0,0,0,0.1)]"
            onClick={() => setShowBranchDrop(!showBranchDrop)}
          >
            <div className="text-xs font-light text-black">
              {selectedBranch ? selectedBranch : "Branch"}
            </div>
          </div> */}

          <FormControl
            sx={{ m: 1, minWidth: 120, color: "#FF8532", border: "none" }}
            size="small"
          >
            <InputLabel id="demo-select-small-label">Branch</InputLabel>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={branch}
              className=""
              // variant="standard"
              label="Branch"
              onChange={handleChange}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {allBranchData &&
                allBranchData.map((item, index) => (
                  <MenuItem
                    key={index}
                    className="text-[#FF8532]"
                    value={item.DEPTNO}
                    // onClick={() => handleBranchClick(item.DEPTNO)}
                  >
                    {item.DEPTNO}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <div className="flex items-center mx-6">
            {/* <FaUserCircle className="w-[30px] h-[30px]" /> */}
            <img
              src={userIcon}
              alt="userIcon"
              className="w-[40px] h-[40px]  rounded-full"
            />
          </div>
          <div>

          <button
            onClick={onSignOut}
            className="flex justify-center items-center bg-red-500 text-white p-1 mr-4 rounded"
          >
            <div className="flex flex-col justify-center items-center text-center ">
              <AiOutlineExport className="w-6 h-5 " />
              <span className="text-[0.5rem]">Sign Out</span>
            </div>
          </button>
          </div>

        </div>

        {/* {showBranchDrop && (
          <div className="w-[100px] bg-[#FF8532] p-2 rounded absolute right-20 top-[65px] z-10 min-h-auto max-h-[250px] overflow-y-scroll">
            {allBranchData &&
              allBranchData.map((item, index) => (
                <div
                  key={index}
                  className="text-white"
                  onClick={() => handleBranchClick(item.DEPTNO)}
                >
                  {item.DEPTNO}
                </div>
              ))}
          </div>
        )} */}
      </div>
    </div>
  );
};

export default NavBar;
